import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagamentosDetalhesPage } from './pagamentos-detalhes.page';

const routes: Routes = [
  { path: '', component: PagamentosDetalhesPage },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagamentosDetalhesRoutingModule { }
